// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


function escape(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

let emailRegexStr = "\\b[\\w\\.-]+@[\\w\\.-]+\\.\\w{2,4}\\b";

let emailRegex = new RegExp(emailRegexStr);

let phoneRegexStr = "\\b(\\+\\d{1,2}\\s)?\\(?\\d{3}\\)?[\\s.-]?\\d{3}[\\s.-]?\\d{4}\\b";

let phoneRegex = new RegExp(phoneRegexStr);

exports.escape = escape;
exports.emailRegexStr = emailRegexStr;
exports.emailRegex = emailRegex;
exports.phoneRegexStr = phoneRegexStr;
exports.phoneRegex = phoneRegex;
/* emailRegex Not a pure module */
